import Link from "@components/Link/Link";
import React from "react";
import { LOGIN_URL, RECOVER_PASSWORD_URL } from "../../constants";

export const shortCodesToReactComponents = (
  shortCodesText: string
): React.ReactNode[] => {
  const mapping: Record<string, React.ReactNode> = {
    "{{log_in}}": (
      <Link href={LOGIN_URL} className="underline">
        login
      </Link>
    ),
    "{{recover_your_password}}": (
      <Link href={RECOVER_PASSWORD_URL} className="underline">
        recover your password
      </Link>
    ),
  };

  const parts = shortCodesText.split(
    /(\{\{log_in\}\}|\{\{recover_your_password\}\})/
  );

  return parts.map((part, index) => {
    if (mapping[part]) {
      return React.cloneElement(mapping[part] as React.ReactElement, {
        key: index,
      });
    }
    return part;
  });
};
